import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Container } from "@/components/common/ui";
import { STATS } from "@/lib/site";

/** Homepage lead-gen band: start a home value estimate right here, finish on the guide page. */
export const HomeValueBand = () => {
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    const f = e.currentTarget.elements;
    const p = new URLSearchParams({ street: f.street.value.trim(), city: f.city.value.trim(), zip: f.zip.value.trim() });
    navigate(`/guides/home-value?${p.toString()}#estimate`);
  };
  const sold = STATS.find((s) => s.label?.toLowerCase().includes("asking"));
  return (
    <section className="bg-ink py-16 text-white sm:py-20" data-testid="home-value-band">
      <Container className="grid gap-10 lg:grid-cols-[1fr_1.15fr] lg:items-center">
        <div>
          <p className="eyebrow !text-brass">Free · Instant · No obligation</p>
          <h2 className="mt-4 font-display text-4xl font-normal leading-tight sm:text-5xl">What's your home worth today?</h2>
          <p className="mt-4 max-w-lg text-[16px] leading-relaxed text-white/80">
            Get an instant estimate from recent nearby sales, then a precise valuation from The Rob Resh Team.
            {sold ? ` ${sold.label}.` : ""}
          </p>
        </div>
        <form onSubmit={submit} className="grid gap-3 rounded-md bg-white p-5 text-ink sm:grid-cols-[1.6fr_1fr_0.7fr] sm:p-6" data-testid="home-value-band-form">
          <input name="street" required minLength={4} placeholder="Street address" autoComplete="address-line1" data-testid="home-value-band-street"
            className="h-12 rounded-md border border-neutral-300 px-3 text-[16px] focus:border-ink focus:outline-none" />
          <input name="city" required placeholder="City" autoComplete="address-level2" data-testid="home-value-band-city"
            className="h-12 rounded-md border border-neutral-300 px-3 text-[16px] focus:border-ink focus:outline-none" />
          <input name="zip" required pattern="\d{5}" inputMode="numeric" maxLength={5} placeholder="ZIP" autoComplete="postal-code" data-testid="home-value-band-zip"
            className="h-12 rounded-md border border-neutral-300 px-3 text-[16px] focus:border-ink focus:outline-none" />
          <button type="submit" data-sfx="chime" data-testid="home-value-band-submit"
            className="flex h-12 items-center justify-center gap-2 rounded-full bg-brass text-[15px] font-medium text-ink transition-colors hover:bg-ink hover:text-white sm:col-span-3">
            Get my instant estimate <ArrowRight className="h-4 w-4" />
          </button>
        </form>
      </Container>
    </section>
  );
};
